<div class="container-fluid hero-background darkbg">
  <div class="hero-container">
    <div class="container">
      <div class="row">
        <div class="col col-lg-6">
          <h1>
            your order to<br />
            cash solution.
          </h1>
          <div class="spchecklist">
            <div class="d-flex">
              <img
                src="/assets/img/static-pages/medigi/v2-images/standalone-icons/check-grad.svg"
                alt="check"
              />
              Improve market access
            </div>
            <div class="d-flex">
              <img
                src="/assets/img/static-pages/medigi/v2-images/standalone-icons/check-grad.svg"
                alt="check"
              />
              Reduce distribution fees
            </div>
            <div class="d-flex">
              <img
                src="/assets/img/static-pages/medigi/v2-images/standalone-icons/check-grad.svg"
                alt="check"
              />
              Bypass multiple vendor enrollments
            </div>
          </div>
          <h2 class="mb-4">pharmaceutical sourcing through digitalization</h2>
          <app-button
            [buttonColor]="'yellow'"
            [buttonText]="'register now'"
            [buttonIcon]="'chevronright'"
            [buttonLink]="'/registration/seller'"
            [buttonType]="'button'"
            (click)="sendToGa('Went to Seller Reg', 'Manufacturer')"
          ></app-button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="container">
    <div class="row align-items-center justify-content-center">
      <div class="col-12">
        <div class="grad-card-green mt-5">
          <div class="row align-items-center">
            <div class="col-md-8">
              <h2 style="font-size: 1.75rem">
                Gain control with your exclusive access, direct storefront
                powered by medigi.
              </h2>
              <p>
                Our software is now available as your own tech-enabled sales
                platform. Accelerate your direct sales approach with advanced
                features and seamless integration.
              </p>
            </div>

            <div class="col-md-4 text-center">
              <a
                class="button yellow"
                href="https://marketing.medigi.com/saas-offering"
                target="_blank"
                >Learn More <i class="dx-icon-chevronright"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid second-container">
  <div class="container">
    <div class="row align-items-center">
      <div class="second-container-left-side col-12 col-xl-5">
        <h2 class="green">why medigi?</h2>
        <p class="main-copy blue">
          Medigi is a digital pharmaceutical marketplace created to connect
          manufacturers with pharmacies for direct sales. We have thousands of
          facilities searching our catalog for products. Boost your portfolio
          exposure today!
        </p>
        <p class="main-copy blue">
          Upload items directly to the marketplace through your customized
          portal, post news and launches, and share important information on
          your domain. Increase your margins and worry less about moving your
          inventory by utilizing medigi’s distinct features.
        </p>
      </div>
      <div class="second-contianer-value-props col-12 col-xl-7">
        <app-value-prop [location]="'manufacturer'"></app-value-prop>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid third-contianer darkbg">
  <div class="container">
    <div class="row justify-content-center cardholer">
      <app-large-card
        class="col card-offset-top"
        [cardType]="'carousel'"
        [cardInfo]="quoteCard"
      ></app-large-card>
    </div>
  </div>

  <div class="container cardsandwich">
    <div class="row align-items-center">
      <div class="third-container-left-side col-12 col-xl-4">
        <h2 class="white">which drugs are listed on medigi?</h2>
        <p class="main-copy">
          Thousands of facilities use our platform to
          <b
            >search medigi for full-dated listings, MedShorts for short-dated
            inventory, and 503B.com for compounded medications.</b
          >
          Our three-channel platform is the best virtual option to increase
          portfolio awareness and sales.
        </p>
      </div>
      <div class="col-12 col-xl-8">
        <app-drug-card class="minusmarge"></app-drug-card>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row justify-content-center">
      <app-large-card
        class="billboard col card-offset-bottom"
        [pageLocation]="'manufacturer'"
        [cardType]="'button'"
      ></app-large-card>
    </div>
  </div>
</div>

<div class="container-fluid fourth-container whitebg">
  <div class="container">
    <div class="row">
      <div class="fourth-container-left-side col-12 col-xl-6 py-6">
        <h3 class="green">HOW IT WORKS</h3>
        <h2 class="darkblue">with medigi, you are in control.</h2>
        <p class="blue">
          You post the products. You get the sale. Our team handles everything
          in between: pharmacy credentials, customer service, tech support,
          portal upgrades, billing and invoicing, customer communication, and
          more.
        </p>
        <p class="blue">
          <b
            >Let us do the hard work so you can
            <span style="white-space: nowrap">do what you do best!</span></b
          >
        </p>
      </div>
      <div class="fourth-container-right-side col-12 col-xl-6 scrollsection">
        <div class="scrollcards">
          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/factory-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 1</h6>
                <p class="step-card-copy text-wrap text-left">
                  List chosen inventory on the medigi platform
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/desktop-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 2</h6>
                <p class="step-card-copy text-wrap text-left">
                  Pharmacies order your product(s) via the platform
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/shipping-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 3</h6>
                <p class="step-card-copy text-wrap text-left">
                  You ship products directly or from your designated 3PL to the
                  ordering pharmacy
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/phone-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 4</h6>
                <p class="step-card-copy text-wrap text-left">
                  Shipments are tracked in real-time; medigi updates facilities
                  directly on order status
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/envelope-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 5</h6>
                <p class="step-card-copy text-wrap text-left">
                  medigi sends consolidated invoices
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/check-ribbon-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 6</h6>
                <p class="step-card-copy text-wrap text-left">
                  Payments are collected on your behalf
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- <app-carousel-static class="stepcards" [type]="'stepcards'" [location]="'manufacturer'"></app-carousel-static> -->
      </div>
    </div>
  </div>
</div>

<div class="fifth-container container-fluid darkbg">
  <div class="container">
    <div class="row">
      <div class="col col-12">
        <div class="d-flex splitheader align-items-baseline mb-4">
          <h3 class="yellow text-uppercase mr-3">Have questions?</h3>
          <h2 class="white">we have answers.</h2>
        </div>
        <app-faq [faqType]="'manufacturer'"></app-faq>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid sixth-container darkbg">
  <div class="container">
    <div class="row">
      <div class="sixth-container-left-side col-12 col-xl-6">
        <h2 class="white">still curious?</h2>
        <p class="white">Read our overview for more information.</p>
        <a class="yellow d-flex align-items-center fw-bold fs-5 mb-4">
          <span
            (click)="openPDF()"
            (click)="sendToGa('Downloaded Seller PDF', 'Manufacturer')"
            >download our overview</span
          >
          <i class="dx-icon-chevronright"></i>
        </a>
      </div>
      <div class="sixth-container-right-side col-12 col-xl-5">
        <h2 class="white">want to learn more?</h2>
        <p class="white mb-4">
          Don’t hesitate to reach out to a representative. Send inquiries to
          info"&#64;medigi.com, call us at 877-733-5633, or connect via live
          chat.
        </p>
        <a class="yellow d-flex align-items-center fw-bold fs-5 mb-4">
          <span
            (click)="openChat()"
            (click)="sendToGa('Opened Chat', 'Manufacturer')"
            >live chat now</span
          >
          <i class="dx-icon-chevronright"></i>
        </a>
      </div>
    </div>
  </div>
</div>
